import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectEnabledUsers = createSelector(
  [
    (store: RootState) => store.users.users,
    (store: RootState) => store.documentShow.signers,
    (store: RootState) => store.documentShow.searchText,
  ],
  (users, signers, searchText) =>
    users.filter(
      ({ id, isSignatureEnabled, name }) =>
        isSignatureEnabled &&
        !signers.find(({ stakeholder = {} }) => {
          if (stakeholder === null) return false;
          return stakeholder.id === id;
        }) &&
        name?.toLowerCase().includes(searchText.toLowerCase().trim())
    )
);
